module.exports = __webpack_public_path__ + "img/operation.1fe3367b.svg";